import { Form, FormItemProps, Select } from "antd"

import DisabledFieldTooltip from "#blocks/Form/DisabledFieldTooltip"
import { getCurrentSemester } from "#utils/semesterHelpers"

const SEMESTERS = {
  A: "Spring",
  B: "Summer",
  C: "Fall",
}

export const semesterLookup = (value: string) => {
  if (!value) return ""

  const val = value.split(" ")
  const year = val[0]
  const semester = val[1] as keyof typeof SEMESTERS

  return `${SEMESTERS[semester]} ${year}`
}

const semesterOptions = (() => {
  const now = new Date()
  const month = now.getMonth()
  const currentYear = now.getFullYear()
  const results = []

  for (let year = 2017; year <= currentYear + 1; year++) {
    if (year <= currentYear) {
      results.unshift(
        { key: `${year}C`, label: `Fall ${year}`, value: `${year} C` },
        { key: `${year}B`, label: `Summer ${year}`, value: `${year} B` },
        { key: `${year}A`, label: `Spring ${year}`, value: `${year} A` }
      )
    } else {
      if (month > 4)
        results.unshift({
          key: `${year}A`,
          label: `Spring ${year}`,
          value: `${year} A`,
        })

      if (month > 7)
        results.unshift({
          key: `${year}B`,
          label: `Summer ${year}`,
          value: `${year} B`,
        })
    }
  }

  return results
})()

export const SemesterOptions = ({
  includeAll = false,
  showOnlyCurrentAndFuture = false,
}: {
  includeAll?: boolean
  showOnlyCurrentAndFuture?: boolean
}) => {
  const filteredOptions = semesterOptions.filter((option) => {
    if (showOnlyCurrentAndFuture) {
      return option.value >= getCurrentSemester()
    }
    return true
  })

  const optionsToRender = includeAll
    ? [{ key: "All", label: "Show All", value: "All" }, ...filteredOptions]
    : filteredOptions

  return optionsToRender.map((option) => (
    <Select.Option key={option.key} value={option.value}>
      {option.label}
    </Select.Option>
  ))
}

const SemesterDropdown = ({
  includeAll = false,
  fieldName = "semester",
  showOnlyCurrentAndFuture = false,
  disabledTooltip,
  formItemProps,
}: {
  includeAll?: boolean
  fieldName?: string | string[]
  showOnlyCurrentAndFuture?: boolean
  disabledTooltip?: string
  formItemProps?: FormItemProps
}) => {
  const disabled = !!disabledTooltip

  return (
    <DisabledFieldTooltip disabled={disabled} tooltip={disabledTooltip}>
      <Form.Item name={fieldName} label="Semester" {...formItemProps}>
        <Select placeholder="Select semester" disabled={disabled}>
          {SemesterOptions({ includeAll, showOnlyCurrentAndFuture })}
        </Select>
      </Form.Item>
    </DisabledFieldTooltip>
  )
}

export default SemesterDropdown
